import instance from '@/api/instance';

export let FetchUploaderLink = function (data) {
    return instance.post(data.action, data)
}